import { DEFAULT_TIMEZONE } from "@recipevault/shared";
import { useAuth } from "./AuthProvider.js";

/**
 * The active household's IANA timezone, synced via GET /me.
 * DEFAULT_TIMEZONE only fills the gap for a stale offline cache written
 * before the field existed — never hardcode a zone anywhere else.
 */
export function useHouseholdTimezone(): string {
  const { me } = useAuth();
  const hhId = me?.user.currentHouseholdId ?? me?.memberships[0]?.householdId ?? null;
  const membership = me?.memberships.find((m) => m.householdId === hhId);
  return membership?.timezone ?? DEFAULT_TIMEZONE;
}
